import { LANG_DEFAULT } from "../constants";
import {
  LANGUAGE_TO_REGION_MAP,
  REGION_DEFAULT,
  SupportedLanguage,
  SupportedRegion,
} from "../models";

export const isTranslationKey = (message: string): boolean =>
  message?.includes(".") && !message.includes(". ");

export const getRegionByLanguage = (
  language: SupportedLanguage = LANG_DEFAULT,
): SupportedRegion => {
  return LANGUAGE_TO_REGION_MAP[language] || REGION_DEFAULT;
};
